import { NotFoundPage } from '~/components';
import {
  AccountSettingAdmin,
  AlertAdmin,
  AgentAdmin,
  Calendar,
  Client,
  Component,
  CRMAdmin,
  DashboardAdmin,
  EstimateAdmin,
  Event,
  FacilityAdmin,
  HomeUser,
  Inventory,
  InvoiceAdmin,
  Operation,
  ProfileAdmin,
  ProjectAdmin,
  ReportAdmin,
  ScheduleAdmin,
  SignUpAdmin,
  TimeClockAdmin,
  Timesheet,
  UserAdmin,
} from '~/pages';

import ForgotPassword from '~/pages/admin/auth/forgot-password/ForgotPassword';
import OtpConfirmation from '~/pages/admin/auth/otp-confirmation/OtpConfirmation';
import ResetPassword from '~/pages/admin/auth/reset-password/ResetPassword';
import { IRouteModel } from '../interface/common';
import LoginAdmin from '~/pages/admin/auth/login-admin/LoginAdmin';
import Equipment from '~/pages/admin/equipment/Equipment';
import Technician from '~/pages/admin/technicians/Technician';
import Distributor from '~/pages/admin/distributor/Distributor';

// Router && Path
export const adminRoute = {
  base: '/admin',
  login: '/login',
  forgotPassword: '/forgot-password',
  optConfirmation: '/otp-confirmation',
  resetPassword: '/reset-password',
  signUp: '/sign-up',
  dashboard: '/dashboard',
  schedule: '/schedule',
  projects: '/projects',
  facilities: '/facilities',
  users: '/users',
  agents: '/agents',
  cRM: '/crm',
  timeClocks: '/time-clocks',
  invoices: '/invoices',
  estimates: '/estimates',
  reports: '/reports',
  profile: '/profile',
  accountSetting: '/account-setting',
  components: '/components',
  calendar: '/calendar',
  events: '/events',
  clients: '/clients',
  operation: '/operation',
  inventories: '/inventories',
  timesheets: '/timesheets',
  equipment: '/equipment',
  alerts: '/alerts',
  technicians: '/technicians',
  distributors: '/distributors',
};

export const userRoute = {
  base: '/',
  home: '/home',
  component: '/component',
};

//#region Admin Routes
export const publicAdminRoutes: IRouteModel[] = [
  {
    path: '*',
    component: NotFoundPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.login}`,
    component: LoginAdmin,
  },
  {
    path: `${adminRoute.base}${adminRoute.forgotPassword}`,
    component: ForgotPassword,
  },
  {
    path: `${adminRoute.base}${adminRoute.optConfirmation}`,
    component: OtpConfirmation,
  },
  {
    path: `${adminRoute.base}${adminRoute.resetPassword}`,
    component: ResetPassword,
  },
  {
    path: `${adminRoute.base}${adminRoute.signUp}`,
    component: SignUpAdmin,
  },
];

export const privateAdminRoutes: IRouteModel[] = [
  {
    path: `${adminRoute.base}${adminRoute.dashboard}`,
    component: DashboardAdmin,
    name: 'Dashboard',
  },
  {
    path: `${adminRoute.base}${adminRoute.schedule}`,
    component: ScheduleAdmin,
    name: 'Schedule',
  },
  {
    path: `${adminRoute.base}${adminRoute.projects}`,
    component: ProjectAdmin,
    name: 'Project',
  },
  {
    path: `${adminRoute.base}${adminRoute.facilities}`,
    component: FacilityAdmin,
    name: 'facilities',
  },
  {
    path: `${adminRoute.base}${adminRoute.users}`,
    component: UserAdmin,
    name: 'User',
  },
  {
    path: `${adminRoute.base}${adminRoute.agents}`,
    component: AgentAdmin,
    name: 'Agent',
  },
  {
    path: `${adminRoute.base}${adminRoute.cRM}`,
    component: CRMAdmin,
    name: 'CRM',
  },
  {
    path: `${adminRoute.base}${adminRoute.timeClocks}`,
    component: TimeClockAdmin,
    name: 'TimeClock',
  },
  {
    path: `${adminRoute.base}${adminRoute.invoices}`,
    component: InvoiceAdmin,
    name: 'Invoice',
  },
  {
    path: `${adminRoute.base}${adminRoute.estimates}`,
    component: EstimateAdmin,
    name: 'Estimate',
  },
  {
    path: `${adminRoute.base}${adminRoute.reports}`,
    component: ReportAdmin,
    name: 'Report',
  },
  {
    path: `${adminRoute.base}${adminRoute.profile}`,
    component: ProfileAdmin,
    name: 'Profile',
  },
  {
    path: `${adminRoute.base}${adminRoute.accountSetting}`,
    component: AccountSettingAdmin,
    name: 'AccountSetting',
  },
  {
    path: `${adminRoute.base}${adminRoute.components}`,
    component: Component,
    name: 'Components',
  },
  {
    path: `${adminRoute.base}${adminRoute.calendar}`,
    component: Calendar,
    name: 'Calendar',
  },
  {
    path: `${adminRoute.base}${adminRoute.events}`,
    component: Event,
    name: 'Event',
  },
  {
    path: `${adminRoute.base}${adminRoute.clients}`,
    component: Client,
    name: 'Client',
  },
  {
    path: `${adminRoute.base}${adminRoute.operation}`,
    component: Operation,
    name: 'Operation',
  },
  {
    path: `${adminRoute.base}${adminRoute.inventories}`,
    component: Inventory,
    name: 'Inventory',
  },
  {
    path: `${adminRoute.base}${adminRoute.timesheets}`,
    component: Timesheet,
    name: 'Timesheet',
  },
  {
    path: `${adminRoute.base}${adminRoute.equipment}`,
    component: Equipment,
    name: 'Equipment',
  },
  {
    path: `${adminRoute.base}${adminRoute.alerts}`,
    component: AlertAdmin,
    name: 'Alert',
  },
  {
    path: `${adminRoute.base}${adminRoute.technicians}`,
    component: Technician,
    name: 'Technician',
  },
  {
    path: `${adminRoute.base}${adminRoute.distributors}`,
    component: Distributor,
    name: 'Distributor',
  },
];
//#endregion Admin Routes

//#region Patient Routes
export const publicUserRoutes: IRouteModel[] = [
  {
    path: '*',
    component: NotFoundPage,
  },
];

export const privateUserRoutes: IRouteModel[] = [
  {
    path: userRoute.home,
    component: HomeUser,
  },
];
//#endregion Patient Routes

export const publicRoutes = [...publicAdminRoutes, ...publicUserRoutes];

export const privateRoutes = [];

export const adminRouteAbsolute = {
  projects: `${adminRoute.base}${adminRoute.projects}`,
  schedule: `${adminRoute.base}${adminRoute.schedule}`,
  dashboard: `${adminRoute.base}${adminRoute.dashboard}`,
  login: `${adminRoute.base}${adminRoute.login}`,
  signUp: `${adminRoute.base}${adminRoute.signUp}`,
  profile: `${adminRoute.base}${adminRoute.profile}`,
  accountSetting: `${adminRoute.base}${adminRoute.accountSetting}`,
};
